export const DEFAULT_AUTH_SUCCESS_ROUTE = '/student/dashboard';

export function getSafeReturnUrl(returnUrl: string | null | undefined): string {
  if (!returnUrl || !isSafeInternalReturnUrl(returnUrl)) {
    return DEFAULT_AUTH_SUCCESS_ROUTE;
  }

  return returnUrl;
}

export function isSafeInternalReturnUrl(returnUrl: string): boolean {
  if (!returnUrl.startsWith('/') || returnUrl.startsWith('//')) {
    return false;
  }

  if (returnUrl.startsWith('/\\') || returnUrl.includes('://')) {
    return false;
  }

  return !returnUrl.startsWith('/auth/login');
}
